import { BlocksIconAttachment } from 'blocks-nextjs/blocks-web-components/components/icon/icons/attachment';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconAttachment = createComponent({ react: React, tagName: 'cat-icon-attachment', elementClass: BlocksIconAttachment });
